import Vue from 'vue'
import Vuex from 'vuex'
import VuexI18n from 'vuex-i18n' // load vuex i18n module
import app from './modules/app'
import User from './modules/User'
import Axios from 'axios'
import Users from './modules/Users'
import Orders from './modules/Orders'
import Categories from './modules/Categories'
import Reports from './modules/reports'
import Publications from './modules/Publications'
import Bls from './modules/Bls'
import Settings from './modules/Settings'

import * as getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  getters,
  modules: {
    app,
    User,
    Users,
    Orders,
    Categories,
    Reports,
    Publications,
    Bls,
    Settings,
  },
  state: {},
  mutations: {},
})

Vue.use(VuexI18n.plugin, store)

const { username, isLogin, token } =
  JSON.parse(localStorage.getItem('user')) ?? {}
if (username && isLogin && token) {
  store.commit('SET_USER_AUTH', { username, isLogin, token })
} else {
  store.commit('CLEAR_USER_DATA')
}

Axios.interceptors.response.use(
  response => {
    return Promise.resolve(response)
  },
  async error => {
    if (error.response.status === 401 || error.response.status === 403) {
      await store.commit('CLEAR_USER_DATA')
    }
    return Promise.reject(error)
  },
)

export default store
